import { Chip } from "@mui/material";

// Marca o que veio da integração externa e não se edita aqui; sem sistema, nada aparece.
export function SeloIntegracao({ sistema }: { sistema?: string }) {
  if (!sistema) return null;
  return <Chip size="small" variant="outlined" color="info" label={sistema} />;
}
